import axios from 'axios';

export function getCampaignStepPieces(campaignId, stepId) {
  return axios
    .post('/api/?entity=campaigns&action=getStepPieces', {campaignId: campaignId, stepId: stepId})
    .then(response => response.data);
}
